import { Button, Checkbox, Link, Tile } from '@Components/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { KeyPeopleRequirementCard } from './Components/KeyPeopleRequirementCard';
import styles from './KeyPeople.module.scss';
import { RiAddCircleFill } from 'react-icons/ri';
import { KeyPeopleListItem } from './Components/KeyPeopleListItem';
import { KeyPerson, KeyPersonRole } from '@Types/KeyPeople';
import { HelpCenterRoutes, Routes } from '@App/paths';
import { getHelpCenterURL } from '@Helpers/helpCenter';
import { useUserContext } from '@Contexts';
import { Controller, useFormContext } from 'react-hook-form';

export const KeyPeople = ({
  setKeyPersonFormOpen,
  keyPeopleRoles,
  keyPeople,
  setKeyPerson,
}: {
  setKeyPersonFormOpen: (setKeyPersonFormOpen: boolean) => void;
  keyPeopleRoles: KeyPersonRole[];
  keyPeople?: KeyPerson[];
  setKeyPerson: (keyPerson: KeyPerson) => void;
}) => {
  const { t } = useTranslation('account');
  const { userData, isUserLoading } = useUserContext();
  const { control, errors } = useFormContext();

  const allKeyRolesFilled = keyPeopleRoles.every((role) => role.amount > 0);
  const subtitle = (
    <Trans
      ns="account"
      i18nKey="tabs.organization.key_people.description"
      components={[
        <>
          <br />
          <br />
        </>,
        <Link href={Routes.CHARITIES_COMMISSION} underline />,
        <Link href={Routes.COMPANIES_HOUSE} underline />,
        <Link
          href={
            userData
              ? getHelpCenterURL({
                  path: HelpCenterRoutes.AWARD_PROCESS,
                  user: userData,
                })
              : ''
          }
          underline
        />,
      ]}
    />
  );

  return (
    <Tile
      title={{
        title: t('tabs.organization.key_people.title'),
        subtitle: subtitle,
      }}
      className={styles.container}
    >
      <div className={styles.container}>
        {!allKeyRolesFilled && (
          <div className={styles.keyPeopleContainer}>
            {keyPeopleRoles.map((role, i) => (
              <KeyPeopleRequirementCard key={i} {...role} />
            ))}
          </div>
        )}
        <div>
          {keyPeople &&
            keyPeople.map((person, i) => (
              <KeyPeopleListItem
                key={i}
                keyPerson={person}
                keyPeopleRoles={keyPeopleRoles}
                setAddPeopleOpen={setKeyPersonFormOpen}
                setKeyPerson={setKeyPerson}
              />
            ))}
          <Button
            buttonType="text"
            onClick={() => setKeyPersonFormOpen(true)}
            startIcon={<RiAddCircleFill className={styles.addPersonButtonIcon} />}
            className={styles.addPersonButton}
          >
            {t('tabs.organization.key_people.add_person')}
          </Button>
        </div>

        <Controller
          name="all_people_submitted"
          control={control}
          defaultValue={false}
          render={({ ref, onChange, value }) => (
            <Checkbox
              inputRef={ref}
              value={ref.current.checked}
              checked={Boolean(value)}
              onChange={(e) => {
                onChange(e.target.checked);
              }}
            >
              {t('tabs.organization.key_people.all_people_submitted')}
            </Checkbox>
          )}
        />
      </div>
    </Tile>
  );
};
